/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { AlertType } from './Alert.types';

/**
 * The props for `<Alert />`.
 */
export interface AlertProps extends SdsDivProps {
  /**
   * List of buttons to display on the alert.
   */
  buttonList?: JSX.Element;

  /**
   * Icon for the "custom" alert type.
   */
  customIcon?: JSX.Element;

  /**
   * Does the alert need a dark background?
   */
  isDark?: boolean;

  /**
   * Alert message.
   */
  message: React.ReactNode;

  /**
   * Alert type.
   */
  type: AlertType;

  /**
   * Set the alert to have a background color based on its type.
   */
  hasBgColor?: boolean;
  /**
   * Set the ARIA level of heading for accessibility purposes.
   */
  headingLevel?: number;
}

/**
 * The default prop values for `<Alert />`.
 */
export const alertDefaults = {
  hasBgColor: false,
  isDark: false,
};
